import { Slot } from '../Slot';
import { SlotType } from '../SlotDefinition';
import { SlotDefinitionMapper } from './SlotDefinitionMapper';

export class SlotMapper {
  static toDto = (slot: Slot): CoreServiceAPI.SlotInstanceDto => {
    const definition = SlotDefinitionMapper.toDto(slot.definition);
    return {
      ...definition,
      instanceId: slot.id,
      type: slot.type
    };
  };

  static toDomain = (dto: CoreServiceAPI.SlotInstanceDto): Slot => {
    const definition = SlotDefinitionMapper.toDomain(dto);
    if (definition.type === SlotType.LINE) {
      return {
        type: SlotType.LINE,
        definition,
        id: dto.instanceId,
        parentId: undefined,
        children: [],
        blockedBy: undefined
      };
    }

    if (definition.type === SlotType.SINGLE) {
      return {
        type: SlotType.SINGLE,
        definition,
        id: dto.instanceId,
        parentId: undefined,
        blockedBy: undefined,
        childId: undefined
      };
    }

    return {
      type: SlotType.PAIR,
      definition,
      id: dto.instanceId,
      parentId: undefined,
      blockedBy: undefined,
      childId: undefined
    };
  };
}
